import React from 'react';
import emailjs from 'emailjs-com';
import styles from './Contact2.module.css';
import contactImage from '../../Images/img-01.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Contact = () => {
  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        'service_7klhidk',
        'template_tc3un46',
        e.target,
        'user_dvgzC0liaVNTAle8MQojx'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <div id="contact" className={styles.bgContact100}>
      <div className={styles.containerContact100}>
        <div className={styles.wrapContact100}>
          <div
            className={`${styles.contact100Pic}  ${styles.jsTilt}`}
            data-tilt
          >
            <img src={contactImage} alt="IMG" />
          </div>

          <form onSubmit={sendEmail} className={styles.contact100Form}>
            <span className={styles.contact100FormTitle}>Get in touch</span>

            <div
              className={styles.wrapInput100}
              data-validate="Name is required"
            >
              <input
                className={styles.input100}
                type="text"
                name="from_name"
                placeholder="Name"
              />
              <span className={styles.focusInput100}></span>
              <span className={styles.symbolInput100}>
                <FontAwesomeIcon icon={faUser} />
              </span>
            </div>

            <div
              className={styles.wrapInput100}
              data-validate="Valid email is required: ex@abc.xyz"
            >
              <input
                className={styles.input100}
                type="text"
                name="from_email"
                placeholder="Email"
              />
              <span className={styles.focusInput100}></span>
              <span className={styles.symbolInput100}>
                <FontAwesomeIcon icon={faEnvelope} />
              </span>
            </div>

            <div
              className={styles.wrapInput100}
              data-validate="Message is required"
            >
              <textarea
                className={styles.input100}
                name="message"
                placeholder="Message"
              ></textarea>
              <span className={styles.focusInput100}></span>
            </div>

            <div className={styles.contactBtn}>
              <input
                className={styles.contactFormBtn}
                type="submit"
                value="Send"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
